import { useEffect, useState } from 'react';

const EBF = window.EulerBeatsFutura;

export function useNotesPlaying() {
  const [notesPlaying, setNotePlaying] = useState(new Set<any>());

  const playNoteHandler = (event: any) => {
    notesPlaying.add(event.note);
    setNotePlaying(new Set<any>(notesPlaying.values()));
  };
  const stopNoteHandler = (event: any) => {
    notesPlaying.delete(event.note);
    setNotePlaying(new Set<any>(notesPlaying.values()));
  };
  const clearNotesPlaying = () => {
    setNotePlaying(new Set<any>());
  };

  useEffect(() => {
    EBF.audio.addListener('playNote', playNoteHandler);
    EBF.audio.addListener('stopNote', stopNoteHandler);
    EBF.audio.addListener('endPiece', clearNotesPlaying);
    return () => {
      EBF.audio.removeListener('playNote', playNoteHandler);
      EBF.audio.removeListener('stopNote', stopNoteHandler);
      EBF.audio.removeListener('endPiece', clearNotesPlaying);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const hasNotePlaying = (
    sectionIndex: number,
    clipIndex?: number,
    variantIndex?: number,
    layerIndex?: number
  ) => {
    const result = Array.from(notesPlaying.values()).find(
      note =>
        // eslint-disable-next-line eqeqeq
        note.context.section.index == sectionIndex &&
        // eslint-disable-next-line eqeqeq
        (clipIndex == null || note.context.clip.index == clipIndex) &&
        // eslint-disable-next-line eqeqeq
        (variantIndex == null || note.context.variant.index == variantIndex) &&
        // eslint-disable-next-line eqeqeq
        (layerIndex == null || note.context.layer.index == layerIndex)
    );
    return !!result;
  };

  return {
    hasNotePlaying,
    clearNotesPlaying,
  };
}
